import { Box, Button, FormField, Header, Link, Modal, Popover, RadioGroup, SelectProps, SpaceBetween, StatusIndicator, Table } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useMemo, useState } from 'react';
import { useGlobalState } from '../../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../../layout';
import { useRouter } from '../../../../router';
import { useStore } from '../../../../store';
const _preserve = React.version;
////import { useStoreAdmin } from '../../../context/useStoreAdmin';
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiCheck, mdiClose, mdiDelete, mdiFileReplaceOutline, mdiLockOpenOutline, mdiLockOutline, mdiSwapHorizontalBold, mdiTimerSand } from '@mdi/js';
import Icon from '@mdi/react';
import { addDays, format } from 'date-fns';
import BadgeCustom from '../../../../../../components/extras/BadgeCustom';
import Confirm from '../../../../../../components/extras/Confirm';
import Favorites from '../../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { ItemDirector, ItemShift } from '../../../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, getUser, setData, setLoading } from '../../../../../commons/functions';
const pageSize = 20;
type OptionDefinition = SelectProps.Option;

export const MembersEtcShiftsRotatePage = () => {
    const { idUser, data, menu } = useGlobalState();
    const [viewPast, setViewPast] = useState(false);

    const [filteredShifts, setFilteredShifts] = useState<any[]>([]);
    const [keyw, setKeyw] = useState<string>("");

    const [shifts, setShifts] = useState<any[]>([]);
    const [shiftsAll, setShiftsAll] = useState<any[]>([]);
    const [shiftReply, setShiftReply] = useState<ItemShift>();
    const [replaceItem, setReplaceItem] = useState<ItemShift>();
    const [shiftReplace, setShiftReplace] = useState<ItemShift>();
    const [shiftExhange, setShiftExchage] = useState<ItemShift>();
    const [shiftSell, setShiftSell] = useState<ItemShift>();
    const [selectedApprovedShift, setSelectedApprovedShift] = useState<any>();
    const [cancelItem, setCancelItem] = useState<any>();
    const [selectedMultipleShift, setSelectedMultipleShift] = useState<any>();

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    //const [loading, setLoading] = useState<boolean>(true);

    const [selectedTarget, setSelectedTarget] = useState<OptionDefinition | null>(null);
    const [usersTows, setUsersTows] = useState<ItemDirector[]>([]);


    const handleCancel = async (item: any) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/exchange.cancel',
                    'JWT': getCookie("JWT"),
                },
                body: JSON.stringify(item)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data) {
                handleRefresh();
                setCancelItem(undefined)
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleReplaceCancel = async (item: any) => {
        try {
            ////console.log(item)
            setLoading(true);
            let body = {
                idShift: item.idShift,
                start: format(addDays(new Date(), -1), 'dd-MM-yyyy'),
                "orderBy": "dateShift",
                "order": "asc",
                "jsonExchange": true
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/replace/cancel',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data) {
                handleRefresh();
                if (data.code === 0) {
                    setReplaceItem(undefined)
                    setSelectedMultipleShift(undefined)
                }
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleReplace = async (item: any) => {
        try {
            ////console.log(item)
            setLoading(true);
            let body = {
                idShift: item.idShift
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/replace/take',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data) {
                handleRefresh();
                if (data.code === 0) {
                    setShiftReplace(undefined)
                    setSelectedMultipleShift(undefined)
                }
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleSubscribe = async (item: any, subscribe: boolean) => {
        try {
            ////console.log(item)
            setLoading(true);
            let body = {
                ...item,
                subscribe: subscribe ? 1 : 0
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/exchange.subscription',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data) {
                handleRefresh();
                if (data.code === 0) {
                    setSelectedMultipleShift(undefined)
                }
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleAprove = async (item: any) => {
        try {
            ////console.log(item)
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/exchange.approve',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(item)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data && data.shifts) {
                handleRefresh();
                if (data.code === 0) {
                    setSelectedApprovedShift(undefined)
                    setShiftReply(undefined)
                }

            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleRefresh = async () => {
        try {
            setShiftSell(undefined);
            setShiftExchage(undefined);
            setLoading(true);
            setShifts([]);
            setShiftsAll([]);

            let body: any = {
                start: format(addDays(new Date(), -1), 'dd-MM-yyyy'),
                orderBy: "dateShift",
                order: "asc",
                jsonExchange: true
            }
            if (viewPast) {
                body.start = format(addDays(new Date(), -60), 'dd-MM-yyyy')
                body.end = format(addDays(new Date(), 0), 'dd-MM-yyyy')
            }

            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.shifts) {

                const flatShifts = data.shifts.filter((s: any) => (s.shift === "AM" || s.shift === "PM")); // && s.jsonExchange.idShift !== undefined
                setShiftsAll(flatShifts);

                const flatShiftSlots = data.shifts.reduce((acc: any, item: any) => {
                    // Check AM Slot: Must have a user AND a non-empty exchange object
                    if (
                        (item.idUserTowing1 !== 0 &&
                            item.jsonExchangeAM &&
                            Object.keys(item.jsonExchangeAM).length > 0) || item.isReplacementOpen === 1
                    ) {
                        acc.push({
                            idShift: item.idShift,
                            dateShift: item.dateShift,
                            shift: "AM",
                            idUser: item.idUserTowing1,
                            userName: item.userTow1,
                            jsonExchange: item.jsonExchangeAM,
                            isPast: item.isPast,
                            isFuture: item.isFuture,
                            isToday: item.isToday,
                        });
                    }

                    // Check PM Slot: Must have a user AND a non-empty exchange object
                    if (
                        (item.idUserTowing2 !== 0 &&
                            item.jsonExchangePM &&
                            Object.keys(item.jsonExchangePM).length > 0) || item.isReplacementOpen === 1
                    ) {
                        acc.push({
                            idShift: item.idShift,
                            dateShift: item.dateShift,
                            shift: "PM",
                            idUser: item.idUserTowing2,
                            userName: item.userTow2,
                            jsonExchange: item.jsonExchangePM,
                            isPast: item.isPast,
                            isFuture: item.isFuture,
                            isToday: item.isToday,
                        });
                    }

                    return acc;
                }, []);


                setShifts(flatShiftSlots);



            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        handleRefresh();
    }, []);


    useEffect(() => {
        if (!keyw.trim()) {
            setFilteredShifts(shifts);
        } else {
            const lowerKeyw = keyw.toLowerCase();
            setFilteredShifts(
                shifts.filter(s => s.keyw.toLowerCase().includes(lowerKeyw))
            );
        }
    }, [keyw, shifts]);


    const status = ((item: any) => {
        ////console.log(item)
        if (item.idUser === idUser) {
            //Es mio

            if (item.isFuture === 1 && item.isReplacementOpen === 1) {
                return (<BadgeCustom onClick={() => {
                    const newItem = {
                        ...item,
                    }
                    setReplaceItem(newItem);
                }} color='red'> <Icon path={mdiFileReplaceOutline} size={0.75} />Cancelar</BadgeCustom>
                )
            }

            if (item?.jsonExchange?.approved === undefined) {
                //Puedo enrocarlo OK
            } else {
                const jsonExchange = item?.jsonExchange;
                //Esta enrocado, verificar si fue o no aprobado
                if (jsonExchange.type === "CLOSE") {
                    if (jsonExchange.approved === 0) {
                        return (<FormField label={<><Icon path={mdiTimerSand} size={1}
                        /> {getUser(jsonExchange.target.idUser, data).displayName}...</>}
                            constraintText={
                                <BadgeCustom onClick={() => setCancelItem(item)} color="red">
                                    Cancelar enroque
                                </BadgeCustom>
                            }
                        >
                            {shiftsAll.find((s: any) => (jsonExchange.target.idShift == s.idShift))?.dateShift} {jsonExchange.target.shift}
                        </FormField>)
                    } else {
                        return (<>Enrocado con {getUser(jsonExchange.approved, data).displayName}...B</>)
                    }
                } else if (jsonExchange.type === "OPEN") {
                    if (jsonExchange.approved === 0) {

                        const shiftSingle = shiftsAll.find((t: any) => t.idUser === idUser);

                        return (
                            <SpaceBetween direction='vertical' size='xs'>


                                {jsonExchange.targets.map((t: any) => {
                                    // AGREGADO: return explícito para que el map devuelva el JSX
                                    return (
                                        <FormField
                                            key={t.idUser}
                                            label={
                                                <>
                                                    {getUser(t.idUser, data).displayName}
                                                    {t.idUser === idUser ? (
                                                        <Link onClick={() => {
                                                            const newItem = {
                                                                ...item,
                                                                // Seguridad: verificamos que exista shiftSingle
                                                                idShift2: shiftSingle?.idShift,
                                                                shift2: shiftSingle?.shift,
                                                            };
                                                            handleSubscribe(newItem, false);
                                                        }}>
                                                            <Icon path={mdiDelete} size={0.75} color='red' />
                                                        </Link>
                                                    ) : ""}
                                                </>
                                            }
                                        >
                                            {/* Buscamos la fecha del turno del postulante */}
                                            {shiftsAll.find((s: any) => s.idShift === t.idShift)?.dateShift} {t.shift}
                                        </FormField>
                                    );
                                })}
                                <SpaceBetween direction='horizontal' size='xs'>
                                    <BadgeCustom
                                        onClick={() => {
                                            if (item.idUser === idUser && jsonExchange.targets.length > 0) {
                                                setSelectedApprovedShift(item);
                                            }
                                        }}
                                        color='violet'>
                                        {jsonExchange.targets.length === 0
                                            ? "Sin inscritos"
                                            :
                                            "Seleccionar aprobación"
                                        }
                                    </BadgeCustom>



                                    <BadgeCustom onClick={() => setCancelItem(item)} color="red">
                                        Cancelar
                                    </BadgeCustom>
                                </SpaceBetween>
                            </SpaceBetween>
                        );
                    } else {
                        return (<>Enrocado con {getUser(jsonExchange.approved, data).displayName}...C</>)
                    }
                }
            }
        } else {
            //No es mio
            ////console.log("No es mio")
            const jsonExchange = item?.jsonExchange;

            if (item.isFuture === 1 && item.isReplacementOpen === 1) {
                return (<BadgeCustom onClick={() => {
                    const newItem = {
                        ...item,
                    }
                    setShiftReplace(newItem)
                    //handleReplace(newItem);
                }} color='indigo'> <Icon path={mdiFileReplaceOutline} size={0.75} />Reemplazar</BadgeCustom>
                )
            }
            if (item?.jsonExchange?.approved !== undefined && item?.jsonExchange?.approved === 0) {
                //Se puede postular
                ////console.log("Se puede postular")
                if (jsonExchange.type === "CLOSE") {
                    ////console.log("Es cerrado")
                    if (jsonExchange.target.idUser === idUser) {
                        //me referencia a mi
                        return (<>
                            <FormField label={getUser(idUser, data).displayName}
                                constraintText={<BadgeCustom color='blue' onClick={() => {
                                    //handleAprove(item);
                                    setShiftReply(item)
                                }}>Responder enroque</BadgeCustom>}
                            >
                                {shiftsAll.find((s: any) => s.idShift === jsonExchange.target.idShift)?.dateShift} {jsonExchange.target.shift}

                            </FormField>
                        </>)
                    } else {
                        return (<FormField label={<><Icon path={mdiTimerSand} size={0.75} />
                            {getUser(jsonExchange.target.idUser, data).displayName}</>}
                            constraintText={<em>Esperando aprobación...</em>}
                        >
                            <>{shiftsAll.find((s: any) => s.idShift === jsonExchange.target.idShift)?.dateShift} {jsonExchange.target.type}</>
                        </FormField>
                        )
                    }

                } else if (jsonExchange.type === "OPEN") {
                    ////console.log("Es abierto")
                    const isPostulated = jsonExchange.targets?.some((t: any) => t.idUser === idUser);
                    const shiftCount = shiftsAll.filter((t: any) => t.idUser === idUser && t.isFuture === 1).length;
                    const shiftSingle = shiftsAll.find((t: any) => t.idUser === idUser && t.isFuture === 1);
                    const selling = shiftsAll.filter((ts: any) => ts.jsonExchange !== undefined && ts.jsonExchange.approved !== undefined &&
                        idUser === ts.jsonExchange.idUser).length;
                    const isInAnother = shiftsAll.some((ts: any) => {
                        const ex = ts.jsonExchange;
                        if (!ex || Object.keys(ex).length === 0) return false;
                        if (ts.idShift === item.idShift && ts.shift === item.shift) return false;
                        const isTargetOfClose = ex.type === "CLOSE" && ex.target?.idShift === item.idShift && ex.target?.shift === item.shift;
                        const isTargetOfOpen = ex.type === "OPEN" && Array.isArray(ex.targets) && ex.targets.some((t: any) => t.idShift === item.idShift && t.shift === item.shift);
                        return isTargetOfClose || isTargetOfOpen;
                    });

                    const myFragment = (<SpaceBetween direction='vertical' size='xs'>
                        {
                            jsonExchange.targets.length === 0 ? `Sin postulantes` : // ${isPostulated} ${isInAnother} ${selling} ${shiftCount}

                                jsonExchange.targets.map((t: any) => {
                                    return (
                                        <FormField label={<>{getUser(t.idUser, data).displayName} {t.idUser === idUser ?
                                            <Link onClick={() => {
                                                const newItem = {
                                                    ...item,
                                                    idShift2: shiftSingle.idShift,
                                                    shift2: shiftSingle.shift,
                                                }
                                                handleSubscribe(newItem, false);
                                            }}><Icon path={mdiDelete} size={0.75} color='red' /></Link> : ""}</>}>
                                            {shiftsAll.find((s: any) => s.idShift === t.idShift)?.dateShift} {t.shift}
                                        </FormField>
                                    )
                                }
                                )}
                    </SpaceBetween>)
                    if (!isPostulated && (isInAnother || selling > 0)) {
                        return (<>{myFragment}</>)
                    }
                    else if (!isPostulated && shiftCount === 0 && item.isFuture === 1) {
                        return (<>{myFragment}
                            <StatusIndicator type="error">
                                No tiene turnos para postular al intercambio
                            </StatusIndicator>
                        </>)
                    }
                    else if (!isPostulated && shiftCount === 1 && item.isFuture === 1) {
                        return (<>{myFragment}
                            <BadgeCustom onClick={() => {
                                const newItem = {
                                    ...item,
                                    idShift2: shiftSingle.idShift,
                                    shift2: shiftSingle.shift,
                                }
                                handleSubscribe(newItem, true);
                            }} color='lime'>
                                Inscribirme
                            </BadgeCustom>
                        </>)
                    } else if (!isPostulated && shiftCount > 1 && item.isFuture === 1) {
                        return (<>{myFragment}<BadgeCustom onClick={() => {
                            setSelectedMultipleShift(item);
                        }} color='lime'>Inscribirme</BadgeCustom></>)

                    } else {
                        return (<>{myFragment}</>)
                    }


                }

            }

        }
    });
    const busyShiftIds = useMemo(() => {
        const ids = new Set();

        shiftsAll.forEach((s: any) => {
            // Add the primary target ID if it exists
            if (s.jsonExchange?.target?.idShift) {
                ids.add(s.jsonExchange.target.idShift);
            }

            // Add all IDs from the targets array if it exists
            if (Array.isArray(s.jsonExchange?.targets)) {
                s.jsonExchange.targets.forEach((t: any) => {
                    if (t.idShift) ids.add(t.idShift);
                });
            }
        });

        return ids;
    }, [shiftsAll]);
    return (
        <CustomAppLayout
            toolsHide={true}
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                < SpaceBetween size="xs" >
                    <Header
                        description={"De turnos de remolcador"}
                        actions={
                            <SpaceBetween direction="horizontal" size="xs">
                                <Favorites />
                            </SpaceBetween>}>
                        Enroques

                    </Header>
                    <Table

                        stripedRows
                        stickyHeader
                        cellVerticalAlign='top'
                        variant='embedded'
                        empty={
                            <Box>
                                No existen enroques disponibles en estos momentos
                            </Box>
                        }

                        columnDefinitions={[
                            {
                                id: "userTow",
                                header: "Turno",
                                cell: (item) => (<FormField label={item.user ?? ""}>
                                    {`${item.dateShift} ${item.shift}`}
                                </FormField>
                                )

                                //sortingField: "displayName",
                            },
                            {
                                id: "actions2",
                                header: "Tipo",
                                width: 140,
                                cell: (item) => (
                                    <Box textAlign='left'>
                                        {item.jsonExchange.type === "CLOSE" ? <Popover triggerType='custom' content={"Solicitar ser enrocado con un turno y remolcador particular"}><Icon path={mdiLockOutline} size={1} />Cerrado</Popover> : item.jsonExchange.type === "OPEN" ? <Popover triggerType='custom' content={"Solicita ser enrocado con cualquier remolcador/turno disponible"}><Icon path={mdiLockOpenOutline} size={1} />Abierto</Popover> : <Popover triggerType='custom' content={"Solicita ser reemplazado por otro remolcador que desee cubrir su turno"}><Icon path={mdiFileReplaceOutline} size={1} />Reemplazo</Popover>}
                                    </Box>
                                )
                            },
                            {
                                id: "actions",
                                header: "Postulante(s)",
                                cell: (item) => status(item)



                            },
                        ]}
                        items={shiftsAll.filter((s: any) => s.jsonExchange.approved !== undefined || s.isReplacementOpen === 1)}
                        selectionType={undefined}
                        trackBy="idShift"
                    />


                    {shiftReply !== undefined && (
                        <Modal header={<Header >Aceptar o rechazar enroque</Header>}
                            onDismiss={() => setShiftReply(undefined)}
                            footer={

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%",
                                    }}
                                >

                                    <Button variant="link" onClick={() => setShiftReply(undefined)}>Cancelar</Button>
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        <Button variant="primary"
                                            onClick={() => handleAprove(
                                                { ...shiftReply, approve: true })}><Icon path={mdiCheck} size={1} /> Aceptar
                                        </Button>
                                        <Button variant="normal"
                                            onClick={() => handleAprove({ ...shiftReply, approve: false })}><Icon path={mdiClose} size={1} /> Rechazar
                                        </Button>
                                    </div>
                                </div>
                            }

                            visible={shiftReply !== undefined}

                        >
                            <SpaceBetween direction='horizontal' size='l'>
                                <FormField label={getUser(shiftReply.jsonExchange.idUser, data).displayName}>
                                    {shiftReply.dateShift} {shiftReply.jsonExchange.shift}
                                </FormField>
                                <Icon path={mdiSwapHorizontalBold} size={2} />
                                <FormField label={getUser(shiftReply.jsonExchange.target.idUser, data).displayName}>
                                    {shiftsAll.find((s: any) => (s.idShift === shiftReply.jsonExchange.target.idShift))?.dateShift} {shiftReply.jsonExchange.target.shift}
                                </FormField>


                            </SpaceBetween>



                        </Modal>
                    )
                    }
                    {
                        selectedApprovedShift !== undefined && (
                            <Modal header={<Header description={`Fecha ${selectedApprovedShift.dateShift} ${selectedApprovedShift.shift} con:`} >Aprobar enroque</Header>}
                                onDismiss={() => setSelectedApprovedShift(undefined)}
                                footer={
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: "100%",
                                        }}
                                    >
                                        <Button variant="link" onClick={() => setSelectedApprovedShift(undefined)}>Cancelar</Button><Button variant="primary"
                                            disabled={selectedApprovedShift.jsonExchange.approved === 0}
                                            onClick={() => handleAprove(selectedApprovedShift)}>Aprobar</Button>
                                    </div>
                                }

                                visible={selectedApprovedShift !== undefined}

                            >
                                <RadioGroup
                                    value={selectedApprovedShift.jsonExchange.approved ?? "0"}
                                    onChange={(e) => {
                                        const newValue = e.detail.value;

                                        // Creamos una copia PROFUNDA del objeto para que React detecte el cambio

                                        setSelectedApprovedShift({
                                            ...selectedApprovedShift,
                                            jsonExchange: {
                                                ...selectedApprovedShift.jsonExchange,
                                                approved: newValue
                                            }
                                        });
                                    }}
                                    items={
                                        selectedApprovedShift.jsonExchange.targets.map((s: any, index: number) => {
                                            const shiftDetails = shiftsAll.find((sA: any) => sA.idShift === s.idShift);

                                            return {
                                                label: `${shiftDetails?.dateShift || ''} ${s.shift} · ${getUser(s.idUser, data).displayName}`,
                                                // Si el valor del RadioGroup representa el ID del usuario elegido:
                                                value: (index + 1)
                                            };
                                        })
                                    }
                                />



                            </Modal>
                        )
                    }


                    {
                        selectedMultipleShift !== undefined && (
                            <Modal header={<Header description={`Usted posee más de 1 turno disponible para enrocar`} >Seleccionar enroque</Header>}
                                onDismiss={() => setSelectedMultipleShift(undefined)}
                                footer={
                                    <Box>
                                        <Box textAlign='left'><Button variant="link" onClick={() => setSelectedMultipleShift(undefined)}>Cancelar</Button></Box>
                                    </Box>
                                }

                                visible={selectedMultipleShift !== undefined}

                            >
                                <RadioGroup
                                    value={"{}"}
                                    onChange={(e) => {
                                        const json = JSON.parse(e.detail.value);

                                        const newItem = {
                                            ...selectedMultipleShift,
                                            idShift2: json.idShift,
                                            shift2: json.shift,
                                        }
                                        handleSubscribe(newItem, true);

                                    }}
                                    items={
                                        // 1. Filtramos los turnos que pertenecen al usuario
                                        shiftsAll
                                            .filter((s: any) => s.idUser === idUser && s.isFuture === 1)
                                            .map((s: any) => ({
                                                // 2. Mapeamos cada turno al formato que requiere el RadioGroup
                                                label: `${s.dateShift} - ${s.shift}`,
                                                disabled: busyShiftIds.has(s.idShift),
                                                description: busyShiftIds.has(s.idShift) ? "Enrocando con otro turno" : "",
                                                value: JSON.stringify({
                                                    idUser: s.idUser,
                                                    idShift: s.idShift,
                                                    shift: s.shift
                                                })
                                            }))
                                    }
                                />



                            </Modal>
                        )
                    }
                    {!!shiftReplace && (
                        <Confirm show={!!shiftReplace} action={'Confirmar'} warning={`Reemplazaré a ${shiftReplace.user} en el turno ${shiftReplace.dateShift} ${shiftReplace.shift} `}
                            subtitle={"Se le asignará el turno y la reserva de remolcador de turno a su nombre, y se le notificará al socio que estaba asignado a ese turno."}
                            onDismiss={() => setShiftReplace(undefined)} onConfirm={() => {
                                handleReplace(shiftReplace);
                            }}
                        />
                    )}
                    {!!cancelItem && (
                        <Confirm show={!!cancelItem} action={'Cancelar'} warning={`Cancelar mi enroque ${cancelItem.jsonExchange.type === "OPEN" ? "abierto" : "cerrado"} del turno ${cancelItem.dateShift} ${cancelItem.shift} `}
                            subtitle={cancelItem.jsonExchange.type === "OPEN" ? "Usuarios inscritos serán notificados de la cancelación." : ""}
                            onDismiss={() => setCancelItem(undefined)} onConfirm={() => {
                                handleCancel(cancelItem);
                            }}
                        />
                    )}
                    {!!replaceItem && (
                        <Confirm show={!!replaceItem} action={'Cancelar'} warning={`Cancelar mi reemplazo de turno ${replaceItem.dateShift} ${replaceItem.shift} `}
                            onDismiss={() => setReplaceItem(undefined)} onConfirm={() => {
                                handleReplaceCancel(replaceItem);
                            }}
                        />
                    )}



                </SpaceBetween >
            }
        />

    );
};
